/* eslint-disable react/no-unknown-property */
import React from 'react';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosCarregue.css';

function CarrosEletricosCarregue() {
  return (
    <>
      <section id="carros-eletricos-carregue">
        <Container>
          <div className="carros-eletricos-carregue-contain">
            <h3 className="carros-eletricos-carregue-title">Carregue seu veículo elétrico</h3>
            <p className="carros-eletricos-carregue-subtitle">
              Existe uma lista de lugares onde geralmente você pode encontrar um carregador de carro
              elétrico com mais facilidade. <br className="only-mobi" />
              Alguns desses lugares são:
            </p>
            <div className="carros-eletricos-carregue-itens-ctn">
              <div className="carros-eletricos-carregue-itens-div">
                <div className="carros-eletricos-carregue-item">
                  <div className="carros-eletricos-carregue-item-img">
                    <picture>
                      <img
                        src="assets/carros-eletricos/icon-cart.svg"
                        alt="Carinho de supermercado"
                      />
                    </picture>
                  </div>
                  <p className="carros-eletricos-carregue-item-txt">Supermercados</p>
                </div>
                <div className="carros-eletricos-carregue-item">
                  <div className="carros-eletricos-carregue-item-img">
                    <picture>
                      <img src="assets/carros-eletricos/icon-car.svg" alt="Estacionamento" />
                    </picture>
                  </div>
                  <p className="carros-eletricos-carregue-item-txt">Estacionamentos</p>
                </div>
              </div>
              <div className="carros-eletricos-carregue-itens-div">
                <div className="carros-eletricos-carregue-item">
                  <div className="carros-eletricos-carregue-item-img">
                    <picture>
                      <img src="assets/carros-eletricos/icon-bag.svg" alt="Sacola de compras" />
                    </picture>
                  </div>
                  <p className="carros-eletricos-carregue-item-txt">Shoppings</p>
                </div>
                <div className="carros-eletricos-carregue-item">
                  <div className="carros-eletricos-carregue-item-img">
                    <picture>
                      <img src="assets/carros-eletricos/icon-airplane.svg" alt="Avião" />
                    </picture>
                  </div>
                  <p className="carros-eletricos-carregue-item-txt">Aeroportos</p>
                </div>
              </div>
              <div className="carros-eletricos-carregue-itens-div">
                <div className="carros-eletricos-carregue-item">
                  <div className="carros-eletricos-carregue-item-img">
                    <picture>
                      <img
                        src="assets/carros-eletricos/icon-market.svg"
                        alt="Vitrine de uma loja"
                      />
                    </picture>
                  </div>
                  <p className="carros-eletricos-carregue-item-txt">Centros comerciais</p>
                </div>
                <div className="carros-eletricos-carregue-item">
                  <div className="carros-eletricos-carregue-item-img">
                    <picture>
                      <img
                        src="assets/carros-eletricos/icon-thunder.svg"
                        alt="Carregamento de veículos elétricos"
                      />
                    </picture>
                  </div>
                  <p className="carros-eletricos-carregue-item-txt">Postos de carregamento</p>
                </div>
              </div>
            </div>
          </div>
          {/* <p className="carros-eletricos-carregue-obs">
            Confira <b>os pontos de carregamento da rede Shell Recharge</b> mais próximos de você:
          </p> */}
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosCarregue;
